module.exports = __webpack_public_path__ + "img/kr-product-card3-item3-step1.f92124b.png";